// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_fkT","cls2":"SearchBox-cls2_09Q SearchBox-cls1_fkT"};